import { render, staticRenderFns } from "./LotteryBoard.vue?vue&type=template&id=0d739604&"
import script from "./LotteryBoard.vue?vue&type=script&lang=js&"
export * from "./LotteryBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports